$(function() {
  
  // Influencer Toggle
  $('.terms-click p.main-link').on('click', function () {
    $(this).toggleClass('active');
    $('.terms-conditions').toggleClass('hide');
  });
  
  // Success Message
  if(window.location.hash) {
    var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
    console.log(hash);
    var div = "#success"+hash;

    $('body').append($('<div/>', {
      id: 'success-message'
    }));
    
    $('#success-message').append($('<div/>', {
      class: 'success-box'
    }));
    
  }
  
  $('#success-message').on('click', function () {
    $(this).remove();
  });

});
